__turbopack_context__.v({
  "container": "ScaleContainer-module__a_VmRq__container",
  "content": "ScaleContainer-module__a_VmRq__content",
  "fullscreenButton": "ScaleContainer-module__a_VmRq__fullscreenButton",
});
